<script setup>
import { ref, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useEntitiesStore } from '@/stores/useEntitiesStore'
import ExpendeduriaItemComponent from './ExpendeduriaItemComponent.vue'
import ExpendeduriaDrawerComponent from './ExpendeduriaDrawerComponent.vue'
import ExpendeduriaFiltersComponent from './ExpendeduriaFiltersComponent.vue'
import AppPagination from '@/components/common/AppPaginationComponent.vue'

const store = useEntitiesStore()
const { expendedurias, loading, currentPage, totalPages, totalItems, pageSize } = storeToRefs(store)

const activeFilters = ref({ 'delegation_id': '28', 'enabled': true }) // Filtro inicial por delegación y estado
const isDrawerOpen = ref(false)
const selectedExpendeduria = ref(null)

onMounted(() => {
  executeSearch()
})

const executeSearch = (page = 1) => {
  console.log('Ejecutando búsqueda con filtros:', activeFilters.value, 'y página:', page)
  store.fetchExpendedurias({
    page,
    ...activeFilters.value,
  })
}

const handleFilter = (filters) => {
  activeFilters.value = filters
  executeSearch(1)
}

const handleReset = () => {
  activeFilters.value = {}
  executeSearch(1)
}

const handlePageChange = (newPage) => {
  executeSearch(newPage)
}

// Abrir drawer con la expendeduria seleccionada
const handleSelect = (expendeduria) => {
  selectedExpendeduria.value = expendeduria
  isDrawerOpen.value = true
}

const handleCloseDrawer = () => {
  isDrawerOpen.value = false
  selectedExpendeduria.value = null
}
</script>

<template>
  <div class="container my-4">
    <div class="card shadow-sm border-0">
      <div class="card-body p-4">

        <!-- COMPONENTE DE FILTROS -->
        <ExpendeduriaFiltersComponent 
          @filter="handleFilter" 
          @reset="handleReset" 
        />

        <!-- TABLA RESPONSIVA -->
        <div class="table-responsive">
          <table class="table table-hover border align-middle mb-0">
            <thead class="table-light text-uppercase text-secondary small">
              <tr>
                <th scope="col">Expendeduría</th>
                <th scope="col">Módems (Env / Com / Dev)</th>
                <th scope="col">Periodo Prueba</th>
                <th scope="col">SEPA</th>
                <th scope="col">Formación</th>
                <th scope="col">Estado & Alerta</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="6" class="text-center py-4 text-muted">
                  <div class="spinner-border spinner-border-sm me-2" role="status"></div>
                  Cargando expendedurías...
                </td>
              </tr>

              <template v-else>
                <ExpendeduriaItemComponent 
                  v-for="item in expendedurias" 
                  :key="item.id" 
                  :expendeduria="item"
                  @select="handleSelect(item)"
                />
                
                <tr v-if="expendedurias.length === 0">
                  <td colspan="6" class="text-center py-4 text-muted">
                    No se encontraron expendedurías.
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

        <AppPagination 
          :current-page="Number(currentPage?.page || currentPage || 1)"
          :total-pages="totalPages"
          :total-items="totalItems"
          :page-size="pageSize"
          @page-change="handlePageChange"
        />

      </div>
    </div>

    <!-- PANEL LATERAL (DRAWER) -->
    <ExpendeduriaDrawerComponent 
      :is-open="isDrawerOpen"
      :expendeduria="selectedExpendeduria"
      @close="handleCloseDrawer"
      @save="handleSaveChanges"
    />
  </div>
</template>